import { MatchStatus } from "types/entities/Match";

import { matchedStatuses } from "modules/MatchingModule/consts/statusLists";

export const checkMatchStatus = (status: MatchStatus): { isMatched: boolean } => {
  return {
    isMatched: matchedStatuses.includes(status),
  }
}
